export default function PlayIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      className={className}
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.34326 18.3076C4.87288 18.3076 4.44954 18.1333 4.07324 17.7847C3.70247 17.4416 3.51709 16.9546 3.51709 16.3237V3.71484C3.51709 3.08398 3.70247 2.59701 4.07324 2.25391C4.44954 1.90527 4.87288 1.73096 5.34326 1.73096C5.55908 1.73096 5.77767 1.76416 5.99902 1.83057C6.22591 1.89697 6.486 2.01595 6.7793 2.1875L17.0308 8.13916C17.4458 8.37712 17.7751 8.64551 18.0186 8.94434C18.2676 9.23763 18.3921 9.59456 18.3921 10.0151C18.3921 10.4412 18.2676 10.8009 18.0186 11.0942C17.7751 11.3875 17.4458 11.6559 17.0308 11.8994L6.7793 17.8511C6.486 18.0171 6.22591 18.1333 5.99902 18.1997C5.77767 18.2716 5.55908 18.3076 5.34326 18.3076Z" />
    </svg>
  );
}
